import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const STAGES = [
  {
    id: 'IDLE',
    num: '01',
    name: 'IDLE',
    descRu: 'Ожидание запуска',
    descEn: 'Awaiting start',
    stepIndex: 0
  },
  {
    id: 'SCAN',
    num: '02',
    name: 'SCAN',
    descRu: 'Поиск открытых портов',
    descEn: 'Open port scanning',
    stepIndex: 1
  },
  {
    id: 'CRACK',
    num: '03',
    name: 'CRACK',
    descRu: 'Подбор словаря',
    descEn: 'Password dictionary attack',
    stepIndex: 2
  },
  {
    id: 'ACCESS',
    num: '04',
    name: 'ACCESS',
    descRu: 'Удаленная консоль',
    descEn: 'Remote console active',
    stepIndex: 3
  }
];

const RconStagesTracker = ({ currentStage = 'IDLE' }) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  // Map stage to index: IDLE=0, SCAN=1, CRACK=2, ACCESS=3
  const activeStageIndex = STAGES.findIndex(s => s.id === currentStage.toUpperCase());
  const activeIndex = activeStageIndex >= 0 ? activeStageIndex : 0;

  return (
    <div className="stages-tracker-card">
      <div className="stages-header">
        <span className="stages-title">
          {isEn ? 'RCON PROCESS STAGES' : 'СТАДИИ ПРОЦЕССА RCON'}
        </span>
      </div>

      <div className="stages-pipeline">
        {STAGES.map((stage, idx) => {
          let stateClass = '';
          const isCompleted = idx < activeIndex;
          const isActive = idx === activeIndex;

          if (isActive) {
            stateClass = 'active';
          } else if (isCompleted) {
            stateClass = 'completed';
          }

          return (
            <div key={stage.id} className={`stage-node ${stateClass}`}>
              <div className="stage-num">
                {isCompleted ? (
                  <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 stroke-black fill-none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                ) : (
                  stage.num
                )}
              </div>
              <div className="stage-info">
                <span className="stage-name">{stage.name}</span>
                <span className="stage-desc">
                  {isEn ? stage.descEn : stage.descRu}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RconStagesTracker;
